<template>
  <b-card>
    <b-card class="env-layout">
      <template #header>
        <h4 class="m-0">
          تعریف متغیر
        </h4>
      </template>
      <b-form class="form-env" @submit.stop.prevent="submitHandler">
        <main-text>
          در این بخش می‌توانید متغیرهای محلی خود را تعریف کرده و در دسترس
          برنامه‌یتان قرار دهید (پس از نوشتن متغیرها بر روی
          <b>ثبت تغییرات</b> کلیک کنید).
        </main-text>
        <b-card class="mb-3">
          <div
            class="form-env-group"
            v-for="envValue in listEnvValue"
            :key="envValue.id"
          >
            <b-form-input placeholder="Key" v-model="envValue.key" />
            <b-form-input placeholder="Value" v-model="envValue.value" />
            <b-button
              pill
              variant="light"
              @click="deleteCustomEnv(envValue.id)"
            >
              <b-icon icon="x"></b-icon>
            </b-button>
          </div>
          <b-button pill variant="light" @click="addCustomEnv">
            <b-icon icon="plus"></b-icon>
            افزودن متغیر جدید
          </b-button>
          <!-- <b-tabs vertical fill nav-class="bg-transparent" card pills>
            <b-tab title="اضافه کردن متغیر"> </b-tab>
            <b-tab title="آپلود فایل ENV">
              <main-text>
                با آپلود .env تان، می توانید متغیرها را به صورت یکجا اضافه
                کنید.پس از کلیک روی ثبت تغیرات عملیات استقرار آغاز خواهد شد.
              </main-text>
              <div class="file-upload-layout">
                <label for="file-env" class="btn btn-light">
                  <input
                    type="file"
                    class="d-none"
                    id="file-env"
                    @change="envUploadChanged"
                    accept=".env"
                  />
                  آپلود فایل (env.*)
                </label>
                <span>{{ fileEnvName }}</span>
              </div>
            </b-tab>
            <b-tab title="ENVهای آماده">
              <main-text>
                <b-icon icon="server" />
                دیتابیس خود را انتخاب کنید تا متغیرهای آن را به برنامه اضافه
                شوند.
              </main-text>
              <hr />
            </b-tab>
          </b-tabs> -->
          <template #footer>
            <main-text>
              اگر در لیست متغیرهای بالا چند متغیر هم‌نام وجود داشته باشد، پس از
              ثبت تغییرات پایین‌ترین آنها اعمال می شود و قبلی‌ها حذف خواهند شد.
            </main-text>
            <error-messages
              :show="ShowAddEnvsError"
              :messages="addEnvsErrorMessages"
              :dismissible="true"
              @dismissed="dismissedAddEnvsError"
            />
            <loading-btn
              type="submit"
              :loading="loadingAddEnvs"
              :disabled="loadingAddEnvs || listEnvValue.length === 0"
              variant="primary"
              :pill="true"
            >
              ثبت تغییرات
            </loading-btn>
          </template>
        </b-card>
        <b-card>
          <!-- <div class="button-group">
            <b-button variant="light">
              <b-icon icon="x"></b-icon>حذف تمامی متغیرها
            </b-button>
            <b-button variant="light">
              <b-icon icon="download"></b-icon>دانلود خروجی متغیرها
            </b-button>
          </div> -->
          <b-table
            :items="envItem"
            :fields="envFields"
            :busy="isBusy"
            responsive
            hover
            table-class="dir-ltr"
            thead-tr-class="table-list-thead-tr"
            tbody-tr-class="table-list-tbody-tr"
          >
            <template #table-busy>
              <loading />
              <error-messages
                :show="showGetListError"
                :messages="getListEnvsErrorMessages"
              />
            </template>
            <template #cell(operation)="data">
              <b-container>
                <b-row>
                  <b-col align-self="center" class="del-value-table">
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      @click="showDeleteModal(data.item.key)"
                    >
                      <b-icon icon="trash"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </template>
          </b-table>
          <delete-envs-modal
            :envKey="deleteEnvKey"
            :visible="visibleDeleteModal"
            @hidden="hiddenDeleteModal"
            @deleteSuccess="getAllENV"
          />
        </b-card>
      </b-form>
    </b-card>
  </b-card>
</template>

<script>
import MainText from "@/components/MainText/MainText";
import { getUserServiceEnvs, addEnvService } from "@/services/service";
import Loading from "@/components/Loading/Loading.vue";
import LoadingBtn from "../../../components/LoadingBtn/LoadingBtn.vue";
import DeleteEnvsModal from "./DeleteEnvsModal.vue";
import ErrorMessages from "../../../components/ErrorMessages/ErrorMessages.vue";
export default {
  name: "AppSettings",
  components: {
    MainText,
    Loading,
    LoadingBtn,
    DeleteEnvsModal,
    ErrorMessages
  },
  data() {
    LoadingBtn;
    return {
      isBusy: false,
      showGetListError: false,
      getListEnvsErrorMessages: [],
      countIdListEnvValue: 0,
      listEnvValue: [],
      fileEnvName: "",
      fileEnv: null,
      envFields: [
        {
          key: "key",
          label: "key",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "value",
          label: "value",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "operation",
          label: "حذف متغیر",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      envItem: [],
      loadingAddEnvs: false,
      ShowAddEnvsError: false,
      addEnvsErrorMessages: [],
      // delete modal variable
      visibleDeleteModal: false,
      deleteEnvKey: ""
    };
  },
  mounted() {
    this.getAllENV();
  },
  methods: {
    dismissedAddEnvsError: function() {
      this.ShowAddEnvsError = false;
    },
    submitHandler: async function() {
      this.loadingAddEnvs = true;
      const [error, data] = await addEnvService({
        serviceId: this.$route.params.serviceId,
        envs: this.listEnvValue
      });
      if (error) {
        this.addEnvsErrorMessages = error;
        this.ShowAddEnvsError = true;
        this.loadingAddEnvs = false;
      } else {
        if (data.apiStatus === 200) {
          this.loadingAddEnvs = false;
          this.listEnvValue = [];
          this.getAllENV();
        } else {
          this.addEnvsErrorMessages = data.apiErrors;
          this.ShowAddEnvsError = true;
          this.loadingAddEnvs = false;
        }
      }
    },
    getAllENV: async function() {
      this.isBusy = true;
      const [error, data] = await getUserServiceEnvs(
        this.$route.params.serviceId
      );
      if (error) {
        this.getListEnvsErrorMessages = error;
        this.showGetListError = true;
        this.isBusy = false;
      } else {
        if (data.apiStatus === 200) {
          this.envItem = data.apiData.map(item => {
            item["operation"] = "";
            return item;
          });
          this.isBusy = false;
        } else {
          this.getListEnvsErrorMessages = data.apiErrors;
          this.showGetListError = true;
          this.isBusy = false;
        }
      }
    },
    deleteCustomEnv: function(id) {
      let tempList = [...this.listEnvValue];
      tempList.map((item, i) => {
        if (item.id === id) {
          tempList.splice(i, 1);
        }
      });
      this.listEnvValue = [...tempList];
    },
    addCustomEnv: function() {
      this.listEnvValue.push({
        id: ++this.countIdListEnvValue,
        key: "",
        value: ""
      });
    },
    envUploadChanged: function(e) {
      const file = e.target.files[0];
      this.fileEnvName = file.name;
      this.fileEnv = file;
    },
    // delete modal method
    showDeleteModal: function(key) {
      this.visibleDeleteModal = true;
      this.deleteEnvKey = key;
    },
    hiddenDeleteModal: function() {
      this.visibleDeleteModal = false;
    }
  }
};
</script>

<style lang="scss">
.env-layout {
  margin-bottom: 10px;

  & .btn {
    display: flex;
    align-items: center;

    & svg {
      margin-left: 5px;
    }
  }
  .form-env {
    width: 100%;

    .file-upload-layout {
      display: flex;
      align-items: center;
      & .btn {
        margin-left: 10px;
      }
    }
    .button-group {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 20px;
    }
    &-group {
      display: flex;
      justify-content: space-between;
      direction: ltr;
      margin-bottom: 15px;

      & .form-control {
        border: 0;
        border-bottom: 2px solid #eee;
        width: 45%;

        &:focus {
          box-shadow: none;
          border-color: #80bdff;
        }
      }
      & button svg {
        margin-left: 0;
      }
    }

    .table-list {
      &-tbody-tr {
        background: #fff;
        &:hover {
          background: #eee;
          cursor: pointer;
        }
        & td {
          vertical-align: middle;
        }
      }
      &-thead-tr {
        background: #6c757d;
        color: #fff;
      }
    }
    .del-value-table {
      display: flex;
      justify-content: center;

      & svg {
        margin: 0;
      }
    }
  }
}
</style>
